import { Action, Reducer } from 'redux'
import { UPDATE_PRICE_REQUEST_ACTION_TYPES } from './actions'
import { IUpdatePriceRequestState, IUpdatePriceRequest, IUpdatePriceResponse } from './types'

const {
  UPDATE_PRICE_REQUEST_FAILURE,
  UPDATE_PRICE_REQUEST_REQUEST,
  UPDATE_PRICE_REQUEST_SUCCESS,
} = UPDATE_PRICE_REQUEST_ACTION_TYPES

const defaultState = {
  priceRequestFetching: false,
} as IUpdatePriceRequestState

interface IRequestAction extends Action<string> {
  payload: {
    requestData: {
      body: {
        updatePriceRequest: IUpdatePriceRequest
      }
    }
  }
}

interface IErrorAction extends Action<string> {
  error: string
}

interface ISuccessAction extends Action<string> {
  payload: IUpdatePriceResponse
}

type UpdatePriceRequestAction = Action<string> | IErrorAction | ISuccessAction

const updatePriceRequestReducer: Reducer<IUpdatePriceRequestState, UpdatePriceRequestAction> = (
  state = defaultState,
  action
) => {
  if (!action) return state

  switch (action.type) {
    case UPDATE_PRICE_REQUEST_REQUEST: {
      const {
        payload: {
          requestData: {
            body: { updatePriceRequest },
          },
        },
      } = action as IRequestAction
      if (
        !updatePriceRequest.linehaul &&
        !updatePriceRequest.allIn &&
        updatePriceRequest.isGeneratedQuoteStored
      ) {
        return {
          ...state,
          priceRequestFetching: false,
          error: (action as IErrorAction).error,
          errorMessage:
            'There was an error submitting your bid information. There is no quoted rate available. This may be because of an issue with the sagemaker API',
        }
      }
      return {
        ...state,
        updatePriceRequest,
        priceRequestFetching: true,
        errorMessage: undefined,
        message: undefined,
      }
    }
    case UPDATE_PRICE_REQUEST_SUCCESS: {
      const { payload: updatePriceResponse } = action as ISuccessAction
      return {
        ...state,
        updatePriceResponse,
        priceRequestFetching: false,
        message: 'Bid information successfully submitted!',
      }
    }

    case UPDATE_PRICE_REQUEST_FAILURE: {
      return {
        ...state,
        priceRequestFetching: false,
        error: (action as IErrorAction).error,
        errorMessage: `There was an error submitting your bid information. ${
          (action as IErrorAction).error
        }`,
      }
    }

    default:
      return state
  }
}

export default updatePriceRequestReducer
